// phone — UAE mobile with a fixed +971 prefix.
//
// The prefix is chrome, not content: the user types "501234567" and the value
// stored (and sent to every carrier) is the full "971501234567" that both
// Orient and the travel provider require. That removes the single most common
// validation failure in the old forms, where users typed "+971 50..." or
// "050..." and got rejected upstream.
import React from "react";
import { InputAdornment, TextField, Typography } from "@mui/material";
import FieldFrame from "./FieldFrame";

const LOCAL_MAX = 9; // 5X XXXXXXX

// "971501234567" / "+971 50 123 4567" / "0501234567" → "501234567"
const toLocal = (value) => {
  let digits = String(value ?? "").replace(/\D/g, "");
  if (digits.startsWith("971")) digits = digits.slice(3);
  if (digits.startsWith("0")) digits = digits.slice(1);
  return digits.slice(0, LOCAL_MAX);
};

const PhoneInput = ({ field, value, error, disabled, onChange, onBlur }) => {
  const id = `f-${field.name}`;
  const local = toLocal(value);

  return (
    <FieldFrame
      label={field.label}
      required={field.required}
      help={field.help}
      error={error}
      htmlFor={id}
    >
      <TextField
        id={id}
        fullWidth
        size="small"
        type="tel"
        variant="outlined"
        name={field.name}
        value={local}
        disabled={disabled}
        error={!!error}
        placeholder={field.placeholder || "50 123 4567"}
        inputProps={{ inputMode: "numeric", maxLength: LOCAL_MAX, "aria-invalid": !!error }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Typography sx={{ color: "#7B6E66", fontWeight: 600, fontSize: "0.875rem" }}>
                +971
              </Typography>
            </InputAdornment>
          ),
        }}
        onChange={(e) => {
          const next = toLocal(e.target.value);
          // Store the carrier-ready E.164-without-plus form, never the local one.
          onChange({ target: { value: next ? `971${next}` : "" } });
        }}
        onBlur={onBlur}
      />
    </FieldFrame>
  );
};

export { toLocal };
export default PhoneInput;
